module.exports = __webpack_public_path__ + "img/PrivateCommunityIcon.3e663ae7.svg";